import { render, staticRenderFns } from "./IndexHelp.vue?vue&type=template&id=a2c37834&scoped=true&"
import script from "./IndexHelp.vue?vue&type=script&lang=js&"
export * from "./IndexHelp.vue?vue&type=script&lang=js&"
import style0 from "./IndexHelp.vue?vue&type=style&index=0&id=a2c37834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c37834",
  null
  
)

export default component.exports